import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { status } = useAuth();
  if (status === 'loading') return <div style={{ color: '#e2e8f0', padding: '2rem', textAlign: 'center' }}>Cargando...</div>;
  if (status === 'unauthenticated') return <Navigate to="/login" replace />;
  return children;
};

export default ProtectedRoute;
